export const ROOT_FONT_SIZE_PX = 16;
export function toRem(px) {
    return `${px / ROOT_FONT_SIZE_PX}rem`;
}
//# sourceMappingURL=toRem.js.map